export const projects = [
  {
    title: "Rudraksha Store",
    description: "Full MERN e-commerce store for Rudraksha products with admin panel and secure checkout.",
    tech: ["MongoDB", "Express", "React", "Node.js"],
    image: "/images/project/rudraksha_store.png",
    website: "https://rudraksha-store.vercel.app",
    github: "https://github.com/jeshanrai/Rudraksha_Store"
  },
 {
  "title": "SuRu",
  "description": "Full-stack MERN platform connecting startup founders with potential partners and collaborators. Features real-time chat, advanced filtering, application management, and secure authentication.",
  "tech": ["MongoDB", "Express", "React", "Node.js", "Socket.io", "JWT", "Vite"],
  "image": "/images/project/suru.png",
  "website": "https://suru-mu.vercel.app/",
  "github": "https://github.com/jeshanrai/Suru"
}
,
  {
    title: "SecureChat",
    description: "Real-time MERN chat application with end-to-end encryption and user authentication.",
    tech: ["MongoDB", "Express", "React", "Node.js", "Socket.io"],
    image: "/images/project/securechat.png",
    website: "https://secure-chat-system.vercel.app",
    github: "https://github.com/jeshanrai/SecureChat-System"
  },
  {
    title: "TypeProgram",
    description: "Typing practice and speed test platform built using the MERN stack.",
    tech: ["MongoDB", "Express", "React", "Node.js"],
    image: "/images/project/typeprogram.png",
    website: "https://typeprogram.vercel.app",
    github: "https://github.com/jeshanrai/TypeProgram"
  },
  {
    title: "Portfolio Tracker",
    description: "Web app to track NEPSE stock portfolios with auto-price updates using API.",
    tech: ["PHP", "MySQL", "Chart.js"],
    image: "/images/project/portfolio-tracker.png",
    website: "https://portfolio-tracker.vercel.app",
    github: "https://github.com/jeshanrai/portfolio_login"
  },
  {
    title: "Birth Certificate System",
    description: "PHP-based online system for registering, verifying, and generating birth certificates.",
    tech: ["PHP", "MySQL", "Dompdf"],
    image: "/images/project/bith.png",
    website: "https://birth-certificate-system.vercel.app",
    github: "https://github.com/jeshanrai/birth_certificate"
  },
  {
    title: "Portfolio Website",
    description: "Modern animated React portfolio showcasing projects, skills, and experience.",
    tech: ["React", "Framer Motion"],
    image: "/images/project/profile.png",
    website: "https://www.jeshanrai.com.np",
    github: "https://github.com/jeshanrai/Personal-Profile"
  },
];
